export const NAME = "seller"
export const FIREBASE_PATH_REVIEWS = "reviews"
